import { MagicConfigMixin, ContentMixin, RoutablePage } from '@gig/magic-common';
import { Mixins, Prop, Watch, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { STATIC_PAGES_NAMESPACE } from '../../store/modules/static-pages/static-pages.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const staticPagesModule = namespace(STATIC_PAGES_NAMESPACE);
let StaticPageComponent = class extends Mixins(MagicConfigMixin, ContentMixin) {
  constructor() {
    super(...arguments);
    this.pages = [];
    this.selectedTab = "";
    this.defaultTab = "";
    this.contentHeaderSlug = "rgp-rgp_header";
    this.defaultRgPageSlug = "rgp_responsible-gaming";
  }
  onCurrentTabChange() {
    this.handleTabChange(this.currentTab);
  }
  onError() {
    this.routeTo({ route: RoutablePage.NOT_FOUND });
  }
  handleTabChange(slug) {
    this.selectedTab = slug;
    this.emitTabChange();
  }
  created() {
    return __async(this, null, function* () {
      var _a;
      const lang = this.magicConfig.language;
      const category = this.category;
      yield this.fetchStaticPagesData(category, lang);
      this.pages = this.getCategory;
      this.selectedTab = this.currentTab;
      this.defaultTab = (_a = this.filteredPages[0]) == null ? void 0 : _a.slug;
      this.emitTabChange();
    });
  }
  fetchStaticPagesData(category, lang) {
    return __async(this, null, function* () {
      try {
        yield this.fetchCategory({ category, lang });
      } catch (error) {
        console.error(error);
      }
    });
  }
  emitTabChange() {
    this.$emit("tab-change", this.selectedTab || this.defaultTab);
  }
  get filteredPages() {
    return this.pages.filter((page) => page.slug !== this.defaultRgPageSlug && page.slug !== this.contentHeaderSlug);
  }
};
__decorateClass([
  staticPagesModule.Getter("getCategory")
], StaticPageComponent.prototype, "getCategory", 2);
__decorateClass([
  staticPagesModule.Action("fetchCategory")
], StaticPageComponent.prototype, "fetchCategory", 2);
__decorateClass([
  Prop(String)
], StaticPageComponent.prototype, "category", 2);
__decorateClass([
  Prop(String)
], StaticPageComponent.prototype, "currentTab", 2);
__decorateClass([
  Watch("currentTab")
], StaticPageComponent.prototype, "onCurrentTabChange", 1);
StaticPageComponent = __decorateClass([
  Component({
    name: "static-pages",
    store
  })
], StaticPageComponent);

export default StaticPageComponent;
